import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'

import ButtonCinestar from '../../../../../../../Buttons/ButtonCinestar/ButtonCinestar'
import Typography from '../../../../../../../Typography/Typography'

import './ChooseCinemaMobile.scss'

const ChooseCinemaMobile = ({
    cinemas,
    currentCinema,
    selectedCinema,
    selectCinemaHandler,
    confirmHandler,
    titleId,
}) => {
    const intl = useIntl()

    const cinemasSelection = cinemas?.filter((cinema) => cinema?.id !== currentCinema?.id)

    return (
        <Container fluid className="choose-cinema-mobile d-flex flex-column">
            <Typography variant={'buttonPrimary'}>{intl.formatMessage({ id: titleId })}</Typography>
            <div className="choose-cinema-mobile--submit">
                <Typography
                    variant={'buttonPrimary'}
                    color={'magentaSecondary'}
                    className={'d-flex justify-content-center align-items-center bg-white'}
                >
                    {selectedCinema?.name ?? ''}
                </Typography>
                <ButtonCinestar
                    variant={'primary-v1'}
                    onClick={() => confirmHandler(selectedCinema)}
                    disabled={!selectedCinema}
                >
                    {intl.formatMessage({ id: 'buttons.confirm' })}
                </ButtonCinestar>
            </div>
            <div className="choose-cinema-mobile--selection">
                {cinemasSelection?.map((cinema) => (
                    <ButtonCinestar variant={'secondary'} key={cinema.id} onClick={() => selectCinemaHandler(cinema)}>
                        {cinema?.name}
                    </ButtonCinestar>
                ))}
            </div>
        </Container>
    )
}

export default ChooseCinemaMobile
